import Vue from 'vue'

import {button, dropdown, dropdownMenu, dropdownItem, form, formItem, input, steps, step, upload, col, datePicker, image, message, loading,dialog} from "element-ui";

Vue.use(button);
Vue.use(dropdown);
Vue.use(dropdownMenu);
Vue.use(dropdownItem);
Vue.use(form);
Vue.use(formItem);
Vue.use(input);
Vue.use(steps);
Vue.use(step);
Vue.use(upload);
Vue.use(col);
Vue.use(datePicker);
Vue.use(image);
Vue.use(loading);
Vue.use(dialog);
Vue.prototype.$message = message;
// Vue.prototype.$notify = Notification;
